const certs = [
  "ISO 9001:2015",
  "HACCP",
  "APEDA",
  "FSSAI",
  "Spices Board",
  "USDA Organic",
  "GLOBALG.A.P.",
  "Halal",
  "Kosher",
];

export default function Certifications() {
  return (
    <section id="certifications" data-testid="certifications-section" className="py-20 md:py-24 bg-white border-y border-[#1A3626]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center reveal">
          <p className="overline">Certifications & Compliance</p>
          <h2 className="mt-3 font-serif-display text-3xl md:text-4xl text-[#1A3626]">
            Trusted, tested, and traceable.
          </h2>
        </div>

        <div className="mt-12 overflow-hidden reveal">
          <div className="flex gap-12 md:gap-16 animate-marquee whitespace-nowrap items-center">
            {[...certs, ...certs].map((c, i) => (
              <span
                key={i}
                className="font-serif-display text-2xl md:text-3xl text-[#1A3626]/40 hover:text-[#C5A059] transition-colors duration-500 tracking-wide"
              >
                {c}
                <span className="ml-12 md:ml-16 text-[#C5A059]/40">·</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
